const firebaseConfig = {
    apiKey: "AIzaSyCjAIhTU65mztTXNp7goZ0yXPA58tkFBwo",
    authDomain: "the-travel-cdddc.firebaseapp.com",
    projectId: "the-travel-cdddc",
    storageBucket: "the-travel-cdddc.appspot.com",
    messagingSenderId: "491110508908",
    appId: "1:491110508908:web:bb2a96bdb787f4cd97ab49"
  };

  export default firebaseConfig;